<div class="topline">
    <div class="dialog-heading">
        <h1 mat-dialog-title>
            {{user ? 'Modify Existing User' : 'Add New User'}}
        </h1>
        <div *ngIf="user" class="user-summary">
            <div class="user-summary-name-email">{{user.firstName}} {{user.lastName}} ({{user.email}})</div>
            <div class="user-summary-id">User ID: {{user.id}}</div>
        </div>
    </div>
    <button mat-fab (click)="playHelpMovie()"><mat-icon>movie</mat-icon></button>
</div>
<div mat-dialog-content>
    <app-user-products *ngIf="canViewProducts" [userId]="user.id"></app-user-products>
    <form class="form" [formGroup]="form">
        <mat-form-field class="rightspacer">
            <mat-label>Partner</mat-label>
            <mat-select formControlName="partner">
                <mat-option *ngFor="let partner of partners" [value]="partner.partnerId">{{partner.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        <section *ngIf="user" class="company-associations" aria-labelledby="company-associations-heading">
            <h2 id="company-associations-heading">Company associations</h2>
            <p *ngIf="companyAssociationsLoadState === 'loading'" role="status">{{companyAssociationsCopy.loading}}</p>
            <p *ngIf="companyAssociationsLoadState === 'error'" class="company-associations-error" role="alert">
                {{companyAssociationsCopy.error}}
            </p>
            <p *ngIf="companyAssociationsLoadState === 'loaded' && companyAssociations.length === 0">
                {{companyAssociationsCopy.empty}}
            </p>
            <div *ngIf="companyAssociationsLoadState === 'loaded' && companyAssociations.length > 0" class="company-associations-table-wrapper">
                <table class="company-associations-table">
                    <thead>
                    <tr>
                        <th scope="col">Company</th>
                        <th scope="col">Direct roles</th>
                        <th scope="col">Team associations</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let association of companyAssociations; trackBy: trackCompanyAssociation">
                        <th scope="row">{{association.companyName}}</th>
                        <td>
                            <ul *ngIf="association.directRoles.length > 0">
                                <li *ngFor="let role of association.directRoles">{{role}}</li>
                            </ul>
                            <span *ngIf="association.directRoles.length === 0">{{companyAssociationsCopy.noDirectRoles}}</span>
                        </td>
                        <td>
                            <ul *ngIf="association.teamAssociations.length > 0">
                                <li *ngFor="let team of association.teamAssociations">{{team.teamName}}</li>
                            </ul>
                            <span *ngIf="association.teamAssociations.length === 0">{{companyAssociationsCopy.noTeamAssociations}}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <mat-form-field>
            <mat-label>Receive Offers</mat-label>
            <mat-select formControlName="receiveOffers">
                <mat-option [value]="1">Yes</mat-option>
                <mat-option [value]="0">No</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters">
            <mat-label>First Name</mat-label>
            <input matInput #input maxlength="50" placeholder="" formControlName="firstname">
            <mat-hint align="end">{{input.value.length || 0}}/50</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters">
            <mat-label>Last Name</mat-label>
            <input matInput #input2 maxlength="50" placeholder="" formControlName="lastname">
            <mat-hint align="end">{{input2.value.length || 0}}/50</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="me@example.com">
            <mat-label>Email</mat-label>
            <input matInput #input3  placeholder="" formControlName="email" [readonly]="!!user">
            <button type="button" *ngIf="!emailVerified && !user" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Save Before Verifying</button>
            <button type="button" *ngIf="emailVerified && user" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Verified</button>
            <button type="button" *ngIf="!emailVerified && user" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="isEmailVerificationDisabled()" (click)="forceVerifyEmail()">Force Verify</button>
            <button type="button" *ngIf="!emailVerified && user" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="isEmailVerificationDisabled()" (click)="verifyEmail()">User Verify</button>
        </mat-form-field>
        <mat-form-field hintLabel="personal@example.com">
            <mat-label>Backup Email</mat-label>
            <input matInput type="email" placeholder="" formControlName="alternateEmail">
            <mat-error *ngIf="form.get('alternateEmail')?.hasError('email')">Enter a valid email address</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="user?.verificationCode">
            <mat-label>Email Last Code Sent</mat-label>
            <input matInput [value]="user.verificationCode" readonly>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Mobile Number</mat-label>
            <input matInput maxlength="10" minLength="10" placeholder="" formControlName="tel" type="tel">
            <!--
            <ngx-mat-intl-tel-input
                    [onlyCountries]="['us']"
                    [enablePlaceholder]="false"
                    [enableSearch]="false"
                    name="tel"
                    formControlName="tel">
            </ngx-mat-intl-tel-input>
            -->
            <button type="button" *ngIf="!phoneVerified && !user" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Save Before Verifying</button>
            <button type="button" *ngIf="phoneVerified && user" matSuffix class="verifybutton" [disabled]="true" mat-raised-button>Verified</button>
            <button type="button" *ngIf="!phoneVerified && user" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="phoneVerified || !!form.get('tel')?.errors || form.get('tel')?.value?.length < 3" (click)="forceVerifyPhoneNumber()">Force Verify</button>
            <button type="button" *ngIf="!phoneVerified && user" matSuffix color="accent" class="verifybutton" mat-raised-button [disabled]="phoneVerified || !!form.get('tel')?.errors || form.get('tel')?.value?.length < 3" (click)="verifyPhoneNumber()">User Verify</button>
        </mat-form-field>
        <mat-form-field *ngIf="user?.lastCode">
            <mat-label>Phone Last Code Sent</mat-label>
            <input matInput [value]="user.lastCode" readonly>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Date of Birth</mat-label>
            <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input matInput placeholder="" formControlName="address1">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input matInput placeholder="" formControlName="address2">
        </mat-form-field>
        <mat-form-field>
            <mat-label>City</mat-label>
            <input matInput placeholder="" formControlName="city">
        </mat-form-field>
        <mat-form-field>
            <mat-label>State</mat-label>
            <app-state formControlName="state"></app-state>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Zip Code</mat-label>
            <input matInput placeholder="" formControlName="postalCode">
        </mat-form-field>
        <mat-form-field>
            <mat-label>SSN</mat-label>
            <div class="ssn-field">
                <input matInput placeholder="*** ** ****" formControlName="ssn" [type]="hideSsn ? 'password' : 'text'">
                <mat-icon class="hide-password-icon" [svgIcon]="hideSsn ? 'icon-eye-lock' : 'icon-eye'" (click)="hideSsn = !hideSsn"></mat-icon>
            </div>
        </mat-form-field>
    </form>
    <div class="buttons" mat-dialog-actions>
        <button mat-raised-button color="primary" class="primarybutton" shape="" [disabled]="saving" (click)="saveClicked($event)">{{saving ? 'Saving...' : 'Save'}}</button>
        <button mat-raised-button (click)="onDismiss()">Cancel</button>
    </div>
</div>
